module.exports = __webpack_public_path__ + "img/42.504f8e5c.jpg";